import { Component, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-expando-button',
    templateUrl: './expando-button.component.html',
    styleUrls: ['./expando-button.component.scss'],
    standalone: false
})
export class ExpandoButtonComponent {
  public onClicked = new EventEmitter();
  expanded = false;

  clicked(event: Event) {
    event.stopPropagation();
    this.expanded = !this.expanded;
    this.onClicked.emit('clicked');
  }
}
